import CardClass from "../../../CardClass";
import Table from "../../../Table";
import { withRouter } from 'react-router-dom';
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminOrderStatusReasonList extends CardClass {
    static contextType = MainContext; // For legacy class components

    
    /**
     * Renders the content of the card.
     */
    renderContent() {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number"},
                    { key: "description", name: "Name", type: "string" },
                    { key: "thirdPartyDescription", name: "Third Party Description", type: "string", width: "400px" },
                    { key: "orderStatus", name: "Status", type: "orderStatus", filter: true },
                ]}
                rows={Object.values(this.context.orderStatusReasonsIndexed)}
                onClick={(orderStatusReason) => {
                    this.props.history.push({
                        pathname: "/admin/orderStatusReason/" + orderStatusReason.id
                    });
                }}
            />
        );
    }
    
});

